import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';

/**
 * @param {import('react').ButtonHTMLAttributes<HTMLButtonElement> & {
 *  innerRef?: React.Ref<HTMLButtonElement>
 *  size?: import('utils/types').ButtonSize
 *  variant?: import('utils/types').ButtonVariant
 *  disabled?: boolean
 *  strictStyles?: boolean
 *  processing?: boolean
 *  processingText?: string
 *  className?: string
 * }} props
 */
export default function Button({
  innerRef = null,
  variant = 'primary',
  size = 'md',
  disabled = false,
  processing = false,
  processingText = '',
  className = '',
  children = null,
  strictStyles = false,
  ...htmlProps
}) {
  return (
    <button
      {...htmlProps}
      ref={innerRef}
      data-size={size}
      data-variant={variant}
      data-strict={strictStyles}
      data-processing={!!processing}
      disabled={disabled || processing}
      className={cn(styles.button, className)}
    >
      <div className={styles.cell}>{children}</div>
      <div className={styles.cell}>
        {processingText}
        <span className={styles.loader}>
          <UiKit.Spinner size="sm" />
        </span>
      </div>
    </button>
  );
}
